export default __webpack_public_path__ + "static/media/Rosaria3.efbfc321.mp3";